//when dom ready,no jquery
document.addEventListener('DOMContentLoaded', function () {
    if(sectionId){
        fetchSectionHtml(sectionId, new URL(window.location.href), { dataType: 'json' })
    }
    backInstock()
    fetchSubscribeCount(productId)
});
const w = [200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800]
function fetchSubscribeCount(productId) {
    var subscribeButton = document.getElementById('subscribe-button')
    if (!productId || !subscribeButton) {
        return
    }
    let url = "https://app.prexhobby.com/product/subscribe-count/"+productId
    fetch(url, { method: 'GET' }).then(response => response.json()).then(data => {
        if (data.data){
            const existingCount = document.getElementById('subscribe-count')
            if (existingCount) {
                existingCount.remove()
            }
            const countSpan = document.createElement('span')
            countSpan.className = 'text-xs'
            countSpan.id = 'subscribe-count'
            countSpan.textContent = `${data.data} people subscribed`
            subscribeButton.appendChild(countSpan)
        }
    })
        
}
function fetchProductsHtml(search) {
    //let url = "http://127.0.0.1:9090/product/query-by-collection"
    let url = "https://app.prexhobby.com/product/query-by-collection"
    if (search) {
        url = url + search + "&collection_id=" + collectionId
    } else {
        url = url + "?collection_id=" + collectionId
    }
    return new Promise((resolve, reject) => {
        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(response => response.json()).then(data => {
            if (data.data.content.length == 0) {
                resolve(null)
                return
            }
            data.data.content.forEach((item) => {
                if (!item.featuredImage) {
                    return
                }
                const list = []
                w.forEach((width) => {
                    if (width < item.featuredImage.width) {
                        list.push(item.featuredImage.url + "&width=" + width + " " + width + "w")
                    }
                })
                item.featuredImage.srcset = list.join(",")
            })
            const clonedUrl = new URL(window.location.href);
            clonedUrl.searchParams.delete("page");
            const filters = []
            const keys = clonedUrl.searchParams.keys()
            //去重
            const filterKeys = new Set()
            for (const key of keys) {
                if (key.indexOf('filter.') >= 0) {
                    filterKeys.add(key)
                }
            }
            for (const key of filterKeys) {
                const values = clonedUrl.searchParams.getAll(key)
                for (const value of values) {
                    filters.push({
                        key,
                        value,
                        url: getFilterRemoveUrl(window.location.href, key, value)
                    })
                }
            }

            const html = template('products', data.data)
            const list = getPagination(data.data.current, data.data.totalPages, clonedUrl)
            const paginationHtml = template('art-pagination', {
                list: list,
                current: data.data.current,
                totalPages: data.data.totalPages,
                totalElements: data.data.totalElements
            })
            const facetsHtml = template('art-facets', {
                list: filters
            })
            resolve({
                html: html,
                pagination: paginationHtml,
                facets: facetsHtml,
                totalElements: data.data.totalElements
            })
            //const ele=document.getElementById('product-list-wrap')
            //get the first child of the element
            //ele.getElementsByClassName('product-list')[0].innerHTML=html
        }).catch((error) => {
            reject(error)
        });
    })
}
function fetchSectionHtml(sectionId, url, data) {
    if (!data || data.dataType !== 'json') {
        //return
    }
    let search = url.search
    const searchParams = new URLSearchParams(search)
    let mSortBy = searchParams.get('sort_by') || sortBy
    if (!mSortBy && defaultSortBy=='created-descending') {
        mSortBy = "custom.product_avail-ascending,custom.created_at-descending"
    }
    if ((!mSortBy || mSortBy.indexOf('custom.') < 0) && !filterBy) {
        return new Promise((resolve, reject) => {
            resolve(false)
        })
    }
    searchParams.set('sort_by', mSortBy.replace('custom.', ''))
    if (filterBy) {
        const filters = filterBy.split(',')
        filters.forEach((filter) => {
            const list = filter.split("=")
            if (list.length != 2) {
                return
            }
            if (!searchParams.has('filter.p.m.custom.' + list[0])) {
                searchParams.set('filter.p.m.custom.' + list[0], list[1])
            }
        })
    }
    search = "?" + searchParams.toString()
    const ele = document.getElementById(`product-list-${sectionId}`)
    const paginationEle = document.getElementById(`pagination`)
    const facetsEle = document.getElementById(`facets`)
    const resultCountEle = document.getElementById(`result-count`)
    return new Promise((resolve, reject) => {
        fetchProductsHtml(search).then((data) => {
            if (!data || !data.html) {
                resolve(true)
                return
            }
            ele.innerHTML = data.html
            if (paginationEle) {
                paginationEle.innerHTML = data.pagination
            }
            if (facetsEle) {
                if (data.facets.trim() == '') {
                    facetsEle.style.display = 'none'
                } else {
                    facetsEle.style.display = 'flex'
                }
                facetsEle.innerHTML = data.facets
            } else {
                const htmlNode = document.createElement('div')
                htmlNode.className = 'active-facets'
                htmlNode.id = 'facets'
                htmlNode.innerHTML = data.facets
                if (data.facets.trim() == '') {
                    htmlNode.style.display = 'none'
                } else {
                    htmlNode.style.display = 'flex'
                }
                document.getElementsByClassName('collection__main')[0].prepend(htmlNode)
            }
            if (resultCountEle) {
                resultCountEle.innerHTML = `${data.totalElements} products`
            }
            changeFilter()
            resolve(true)
        }).catch((error) => {
            console.error(error)
            resolve(false)
        })
    })
}
function changeFilter() {
    const url = new URL(window.location.href)
    const searchParams = new URLSearchParams(url.search)
    let count = 0
    document.querySelectorAll('facets-form details input[name*="filter."]').forEach((checkbox) => {
        checkbox.checked = false
    })
    for (const key of searchParams.keys()) {
        if (key.indexOf('filter.') >= 0) {
            count++
            const checkboxs = document.querySelectorAll(`input[name="${key}"]`)
            checkboxs.forEach((checkbox) => {
                if (searchParams.getAll(key).indexOf(checkbox.value) >= 0) {
                    checkbox.checked = true
                } else {
                    checkbox.checked = false
                }
            })
        }
    }
    const btn = document.getElementById('filter-btn')
    const label = btn.getAttribute('aria-label')
    btn.innerHTML = count > 0 ? `${label} (${count})` : `${label}`
}
function getPagination(currentPage, totalPages, url) {
    const pagination = [];
    const maxVisiblePages = 7; // 可以调整最大可见页码数量

    // 添加上一页按钮
    if (currentPage > 1) {
        pagination.push({
            part: `prev`,
            url: getPaginationUrl(url, currentPage - 1)
        });
    }

    if (totalPages <= maxVisiblePages) {
        // 如果总页数小于或等于最大可见页码数量，直接返回所有页码
        for (let i = 1; i <= totalPages; i++) {
            pagination.push({
                part: i,
                url: getPaginationUrl(url, i)
            });
        }
    } else {
        if (currentPage <= 4) {
            // 当前页码在前4页时，显示前5页、...、最后一页
            for (let i = 1; i <= 5; i++) {
                pagination.push({
                    part: i,
                    url: getPaginationUrl(url, i)
                });
            }
            pagination.push({
                part: '...',
            });
            pagination.push({
                part: totalPages,
                url: getPaginationUrl(url, totalPages)
            });
        } else if (currentPage > totalPages - 4) {
            // 当前页码在最后4页时，显示第一页、...、后5页
            pagination.push({
                part: 1,
                url: getPaginationUrl(url, 1)
            });
            pagination.push({
                part: '...',
            });
            for (let i = totalPages - 4; i <= totalPages; i++) {
                pagination.push({
                    part: i,
                    url: getPaginationUrl(url, i)
                });
            }
        } else {
            // 当前页码在中间时，显示第一页、...、当前页前2页、当前页、当前页后2页、...、最后一页
            pagination.push({
                part: 1,
                url: getPaginationUrl(url, 1)
            });
            pagination.push({
                part: '...',
            });
            for (let i = currentPage - 2; i <= currentPage + 2; i++) {
                pagination.push({
                    part: i,
                    url: getPaginationUrl(url, i)
                });
            }
            pagination.push({
                part: '...',
            });
            pagination.push({
                part: totalPages,
                url: getPaginationUrl(url, totalPages)
            });
        }
    }

    // 添加下一页按钮
    if (currentPage < totalPages) {
        pagination.push({
            part: `next`,
            url: getPaginationUrl(url, currentPage + 1)
        });
    }

    return pagination;
}
function getFilterRemoveUrl(url, key, value) {
    const clonedUrl = new URL(url);
    const searchParams = new URLSearchParams();
    for (const [k, v] of clonedUrl.searchParams) {
        if (k !== key || v !== value) {
            searchParams.append(k, v)
        }
    }
    return clonedUrl.pathname + "?" + searchParams.toString()
}
function getPaginationUrl(url, page) {
    const clonedUrl = new URL(url);
    clonedUrl.searchParams.set("page", page);
    return clonedUrl.pathname + clonedUrl.search
}

function backInstock() {
    document.addEventListener('click', (e) => {
        const btn = e.target.closest('.back-instock')
        const closeBtn = e.target.closest('#back-instock-close')
        const gSubscribeBtn = e.target.closest('#gSubscribeBtn')
        if (btn) {
            const str = btn.getAttribute('data-product') || "{}"
            const product = JSON.parse(str)
            product.title =btn.getAttribute('data-title') || ""
            const html = template('back-instock', product)
            document.body.insertAdjacentHTML('beforeend', html)
        }

        if (closeBtn) {
            const modal = document.getElementById('Globo-Back-In-Stock-Popup')
            modal.remove()
        }
        if (gSubscribeBtn) {
            handleSubmitBis()
        }
    })
}
function handleSubmitBis() {
    const gSubscribeBtn = document.getElementById('gSubscribeBtn')
    const emailEle = document.getElementById('gBackInStock-Form-Product-Email')
    const productId = document.getElementById('gBackInStock-Form-Product-Id').value
    const variantId = document.getElementById('gBackInStock-Form-Variant-Id').value
    const formData = new FormData()
    const data = {}
    data['shop'] = 'aot-supply.myshopify.com'
    data['locale'] = 'en'
    data['notification'] = 'email'
    data['content[keyLabel]'] = '{}'
    data['email'] = emailEle.value
    data['productId'] = productId
    data['variant_id'] = variantId
    const formControl = emailEle.parentElement

    //验证email 
    if (!validateEmail(emailEle.value)) {
        formControl.classList.add('has-error')
        const msgEle = formControl.querySelector('.gBackInStock-messages')
        msgEle.classList.add('gBackInStock-messages-error')
        msgEle.innerHTML = 'The email address you entered is invalid'
        emailEle.focus()
        return
    } else {
        formControl.classList.remove('has-error')
        const msgEle = formControl.querySelector('.gBackInStock-messages')
        msgEle.classList.remove('gBackInStock-messages-error')
        msgEle.innerHTML = ''
    }
   
    gSubscribeBtn.classList.add('button--loading')
    // let url = "http://127.0.0.1:9090/subscribe/create"
    let url = "https://app.prexhobby.com/subscribe/create"
    
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then(response => response.json()).then(data => {
        let html = ""
        if (data.code == 0) {
            html = `<div class="gBackInStock-Form-Message">
            <p class="gBackInStock-Message gBackInStock-Message-Success">${data.data}</p>
        </div>`

        } else {
            html = `<div class="gBackInStock-Form-Message">
            <p class="gBackInStock-Message gBackInStock-Message-Error">${data.msg}</p>
        </div>`
        }
        const ele = document.getElementById('Globo-Back-In-Stock-Popup').querySelector('.Globo-body-footer')
        const msg = ele.querySelector('.gBackInStock-Form-Message')
        if (msg) {
            msg.remove()
        }
        ele.insertAdjacentHTML('beforeend', html)
    }).finally(() => {
        gSubscribeBtn.classList.remove('button--loading')
    })
}
function validateEmail(email) {
    return /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(email)
}